import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Legacy "Content results" URL — the page became the batch's Insights tab (2026-10-16). Redirects
 * old links/bookmarks there so nothing 404s.
 */
export const Route = createFileRoute(
  '/_authenticated/_tenant/catalog-enrichment/runs/$runId/content-results',
)({
  beforeLoad: ({ params }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router requires throwing a redirect
    throw redirect({
      to: '/catalog-enrichment/runs/$runId/insights',
      params: { runId: params.runId },
      replace: true,
    });
  },
});
